import { toast } from 'sonner';
import { API_ENDPOINTS, HTTP_METHODS } from '../config/api';
import { BaseApiService, ApiResponse } from './baseApi';

export interface InvoiceSalesReportRow {
  voucherNumber?: string;
  invoiceDate?: string;
  voucherType?: string;
  partyName?: string;
  vehicleNumber?: string;
  customerAddress?: string;
  gstin?: string;
  pan?: string;
  itemName?: string;
  hsnCode?: string;
  godown?: string;
  itemBatch?: string;
  actualQuantity?: number;
  billedQuantity?: number;
  rate?: number;
  unit?: string;
  amount?: number;
  cgstRate?: number;
  sgstRate?: number;
  igstRate?: number;
  cgstAmount?: number;
  sgstAmount?: number;
  igstAmount?: number;
  tcsRate?: number | null;
  tcsAmount?: number;
  otherCharges?: number;
  totalTaxAmount?: number;
  grandTotal?: number;
  additionalRemarks?: string;
  status?: string;
}

class InvoiceSalesReportApiService extends BaseApiService {
  async getInvoiceSalesReport(
    branchId?: number,
    startDate?: string,
    endDate?: string
  ): Promise<ApiResponse<InvoiceSalesReportRow[]>> {
    try {
      const response = await this.makeRequest<ApiResponse<InvoiceSalesReportRow[]> | InvoiceSalesReportRow[]>(
        API_ENDPOINTS.INVOICE_REPORTS.SALES(branchId, startDate, endDate),
        { method: HTTP_METHODS.GET }
      );

      if (Array.isArray(response)) {
        return {
          success: true,
          message: 'Invoice sales report fetched successfully',
          data: response,
        };
      }

      return {
        success: Boolean(response?.success),
        message: response?.message || 'Invoice sales report fetched successfully',
        data: Array.isArray(response?.data) ? response.data : [],
        timestamp: response?.timestamp,
        pagination: response?.pagination,
      };
    } catch (error) {
      toast.error('Failed to fetch invoice sales report');
      throw error;
    }
  }
}

export const invoiceSalesReportApiService = new InvoiceSalesReportApiService();
